export const pluralize = (word, count) => {
  return word + (count > 1 ? "s" : "")
}

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

export const toKebab = (str) =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join("-")
